enum EigenApiServer {
  Sandbox1 = 1,
  Sandbox2 = 2,
  Production1 = 3,
  Production2 = 4,
}

export { EigenApiServer };
